import axios from 'axios';
import {GetGaUserCode, GetUserIdCookie} from "../commom/userCode";
import env from "../env";
import {getAuthToken} from "../commom/authToken";
import {getLocalStorage, LOCAL_STORAGE_KEY_ACCESS_TOKEN} from "../commom/localStorage";
import Cookies from 'universal-cookie';
import { isWriteWhitelisted } from "../accessControl/freemium";
import { isFreemiumReadOnlyNow } from "../accessControl/guard";
import { openFreemiumUpsell } from "../stores/freemiumUpsellStore";
import { SOCIAL_AUTH_PROVIDER_IDS } from "../../modules/Auth/constants/socialAuth";
import { isOptionalAuthRequest } from "./optionalAuth";

const axiosInstance = axios.create({
    baseURL: env.REACT_APP_API_URL,
});

/*
*  Modo somente-leitura do freemium: bloqueia mutações (POST/PUT/PATCH/DELETE)
*  fora de /disciplinas, exceto os endpoints da whitelist. Rede de segurança de
*  UX — a validação real de permissão é responsabilidade do backend.
* */
const MUTATION_METHODS = ['post', 'put', 'patch', 'delete'];

axiosInstance.interceptors.request.use(
    (config) => {
        const method = (config.method || 'get').toLowerCase();
        const isMutation = MUTATION_METHODS.includes(method);

        if (!isMutation) return config;

        if (isFreemiumReadOnlyNow() && !isWriteWhitelisted(config.url)) {
            openFreemiumUpsell();
            return Promise.reject(new axios.Cancel('freemium-readonly'));
        }

        return config;
    },
    (error) => Promise.reject(error)
);

/*
*  adiciona o token de autenticação nas requisições
* */
axiosInstance.interceptors.request.use(
    (config) => {
        const token = getAuthToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        console.log(error)
        return Promise.reject(error);
    }
);

/*
*   adiciona no body das requisições post o uniqueGaId e userIdCookie
*   dados usados para rastrear atividades dos usuários
* */
axiosInstance.interceptors.request.use(
    (config) => {
        if (config.method === 'post') {
            config.data = {
                ...config.data,
                uniqueGaId: GetGaUserCode(),
                userIdCookie: GetUserIdCookie()
            };
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/*
* Interceptador de resposta para tratar sessão inválida.
* 403: token expirado (fluxo antigo do identifyUser).
* 401: rota protegida por requireAuthenticatedUser sem token válido.
*/
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorStatus = error.response?.status;
    const requestUrl = error.config?.url || '';
    /*
     * O 401 de um login social é a recusa do próprio login, não uma sessão
     * expirada: mandar para /logout apagaria o erro da tela antes de o usuário
     * lê-lo. A checagem é por provedor derivado da lista, e não um `includes`
     * por provedor, para que um provedor novo não precise lembrar disto.
     */
    const isSocialAuthRequest = SOCIAL_AUTH_PROVIDER_IDS.some((provider) =>
      requestUrl.includes(`/auth/${provider}`)
    );
    const isLogoutRequest = requestUrl.includes('/auth/logout');

    if (
      (errorStatus === 403 || errorStatus === 401) &&
      !isSocialAuthRequest &&
      !isLogoutRequest &&
      !isOptionalAuthRequest(requestUrl)
    ) {
      window.location.href = '/logout';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
